import type { RefObject } from 'react'
import { useState, useEffect } from 'react'

import { useBreakpoints } from '@vfuk/core-match-media'

function getElementHeight(ref: RefObject<HTMLDivElement>): number {
  const [elementHeight, setElementHeight] = useState(0)

  const breakpoints = useBreakpoints()

  const handleResize = (): void => {
    setElementHeight(ref.current?.clientHeight ?? 0)
  }

  useEffect(() => {
    setElementHeight(ref.current?.clientHeight ?? 0)
    window.addEventListener('resize', handleResize, false)
    return (): void => {
      window.removeEventListener('resize', handleResize)
    }
  }, [breakpoints])

  return elementHeight
}

export default getElementHeight
